/**
 * Created by haluk on 5/15/17.
 */

import Vue from 'vue';

export default new Vue();
